/** Shopify CDN: Minification failed

Line 37:1 Transforming async functions to the configured target environment ("es5") is not supported yet
Line 39:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 39:10 Transforming destructuring to the configured target environment ("es5") is not supported yet
Line 41:54 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 47:14 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 51:21 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 55:17 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 55:18 Transforming destructuring to the configured target environment ("es5") is not supported yet

**/
/** Shopify CDN: Minification failed

Line 25:1 Transforming async functions to the configured target environment ("es5") is not supported yet
Line 27:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 27:10 Transforming destructuring to the configured target environment ("es5") is not supported yet
Line 29:54 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 35:14 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 39:21 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 43:17 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 43:18 Transforming destructuring to the configured target environment ("es5") is not supported yet

**/
/** Shopify CDN: Minification failed

Line 13:1 Transforming async functions to the configured target environment ("es5") is not supported yet
Line 15:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 15:10 Transforming destructuring to the configured target environment ("es5") is not supported yet
Line 17:54 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 23:14 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 27:21 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 31:17 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 31:18 Transforming destructuring to the configured target environment ("es5") is not supported yet

**/
(async () => {

    const { Core } = await importModule('Core');

    customElements.define('product-options-dropdown', class extends Core {
        elements = {
            dropdown: 'drop-down',
            current: '[data-current]'
        }

        render() {
            this._handleChange();
        }

        _handleChange() {
            this.addEventListener('change', this._onChange.bind(this));
        }

        _onChange({ target }) {
            this.$current.textContent = target.value;
            this.$dropdown.close();
        }
    });

})();